<template>
  <div id="content-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-2 pb-4">
            <b-button block variant="primary" outline size="lg" @click="createExport()">
              <i class="fas fa-plus"></i>
              Generate export
            </b-button> 
        </div>
      </div>
      <!-- <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body class="pt-0">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col>
                      <h4 class="card-title">Search by</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-group class="mb-0">
                        <b-form-input
                          id="exampleInputText1"
                          type="text"
                          placeholder="enter name"
                          size="sm"
                          v-model="search"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </div> -->
      <div class="row">
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-table
                hover
                responsive
                :items="items"
                :fields="fields"
                class="mb-0 table-borderless"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                sort-icon-left
              >
                <template #table-busy>
                  <div class="text-center p-4" style="color: var(--iq-primary)">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(id)="data">
                    <span  v-if="!data.item.readyToDownload" style="padding-left: 12px; opacity: .5;">{{ data.item.id }}</span>
                    <b-button v-if="data.item.readyToDownload" variant="link" style="color: var(--iq-primary)" @click="download(data.item.id)">
                      {{ data.item.id }}
                    </b-button>
                </template>
                <template v-slot:cell(progress)="data">
                  <i class="fa fa-check mr-2" v-if="data.value === 1"></i>
                  <i class="fas fa-spinner fa-spin mr-2" v-else></i>
                  {{ data.value * 100 }} %
                </template>
                <template v-slot:cell(error)="data"
                  >{{ data.value || '-'}} </template
                >
                <template v-slot:cell(created_at)="data">
                  <h6>{{ data.value | formatDate }}</h6>
                </template>
              </b-table>
            </template>
          </iq-card>
        </b-col>
      </div>
      <div class="row d-flex justify-content-center">
        <b-pagination
          value="3"
          size="md"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* .row-shadow {
  transition: 0.2s;
}
.row-shadow:hover {
  transition: 0.2s;
  scale: 1.15;
  transform: scale(1.03);
  cursor: pointer;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
} */
</style>
<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
import decodeBase64 from '../../Utils/decodeBase64';
import sanitizeForCSVExport from '../../Utils/sanitizeForCSVExport';
const LIST_EXPORTS = gql`
  query listExports(
    $where: data_exports_bool_exp!
    $order_by: [data_exports_order_by!]
    $limit: Int!
    $offset: Int!
  ) {
    data_exports_aggregate(order_by: $order_by, where: $where) {
      aggregate {
        totalCount: count
      }
    }
    data_exports(
      limit: $limit
      offset: $offset
      order_by: $order_by
      where: $where
    ) {
      id
      created_at
      number_of_contacts
      progress
      error
    }
  }
`;
const GET_EXPORT = gql`
  query getExport($id: uuid!) {
    data_exports_by_pk(id: $id){
      id
      data
    }
  }
`;
const CREATE_EXPORT = gql`
  mutation createExport {
    insert_data_exports_one(object: {
    }){
      id
      error
      number_of_contacts
      created_at
    }
  }
`;
export default {
  name: "Exports",
  data() {
    return {
      sortBy: "created_at",
      sortDesc: true,
      dataExports: [],
      search: "",
      rows: null,
      perPage: 25,
      currentPage: 1,
      error: false,
      loading: false,
      fields: [
        { key: "id", title: "ID", sortable: true },
        { key: "error", title: "Error", sortable: false },
        { key: "number_of_contacts", title: "Contacts", sortable: true },
        { key: "progress", title: "Progress", sortable: true },
        { key: "created_at", title: "Created at", sortable: true }
      ],
      toDeleteItem: null
    };
  },
  apollo: {
    dataExports: {
      query: LIST_EXPORTS,
      fetchPolicy: "no-cache",
      pollInterval: 10000,
      variables() {
        const vars = {
          where: {},
          // pagination
          limit: this.perPage,
          offset: this.currentPage * this.perPage - this.perPage
        };

        // sorting
        if (this.sortBy !== "") {
          vars.order_by = {
            [this.sortBy]: this.sortDesc ? "desc" : "asc"
          };
        }

        // filter
        const whereAttributes = [];
        if (this.search) {
          whereAttributes.push({
            list_name: {
              _ilike: `%${this.search}%`
            }
          });
        }
        if (whereAttributes.length > 0) {
          vars.where = {
            _and: whereAttributes
          };
        }

        return vars;
      },
      update: data => {
        return data.data_exports.map(i => {
          return {
            id: i.id,
            number_of_contacts: i.number_of_contacts,
            created_at: i.created_at,
            progress: i.progress,
            error: i.error
          };
        });
      },
      result({ data, loading, networkStatus }) {
        if (!loading) {
          this.rows = data.data_exports_aggregate.aggregate.totalCount;
        }
      }
    }
  },
  computed: {
    items() {
      const d = this.dataExports.map(di => {
        return {
          id: di.id,
          number_of_contacts: di.number_of_contacts,
          created_at: di.created_at,
          progress: di.progress,
          readyToDownload: di.progress === 1 ? true : false,
          error: di.error
        };
      });
      return d;
    }
  },
  methods: {
    async download(id){
       try {
        this.$toast.success(`Download started`);
        const {data: {data_exports_by_pk}} = await this.$apollo.mutate({
          mutation: GET_EXPORT,
          variables: {
            id
          }
        });
        const exportData = data_exports_by_pk.data;
        const decodedData = decodeBase64(exportData);
        const sanitized = sanitizeForCSVExport(decodedData);
        
        // artificially create file
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + sanitized);
        element.setAttribute('download', `export-${id}.csv`);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.$toast.success(`Download finished`);
      } catch (error) {
        this.$toast.error(`Failed to download export: ${error.message}`);
      }
    },
    async createExport(){
        try {
        await this.$apollo.mutate({
          mutation: CREATE_EXPORT,
        });
        this.$apollo.queries.dataExports.refetch();
        this.$toast.success(`Export created`);
      } catch (error) {
        this.$toast.error(`Failed to create export: ${error.message}`);
      }
    }
  },
  mounted() {
    core.index();
  }
};
</script>
